import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { ApiClientService } from './../../shared/services/api-client.service';
import { AB_API_REQUEST_LOGIN_TOOL } from '../../shared/constants';

interface NewTokenRequestModel {
  tokenType: string;
  mobileDeviceType: string;
  dateOfBirth: Date;
  username: string;
  reason: string;
  name: string;
  pickupBranch: string;
}

interface NewTokenRequestResult {
  callIsSuccess: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class RequestLoginToolService extends ApiClientService {
  constructor(http: HttpClient) {
    super(http, AB_API_REQUEST_LOGIN_TOOL);
  }

  public send(message: NewTokenRequestModel) {
    return this.putWithButtonLoader(message);
  }
}

export { NewTokenRequestModel, NewTokenRequestResult };
